import enLang from './entries/en-US';
import viLang from './entries/vi-VN';
import jpLang from './entries/ja-JP';

const AppLocale = {
  en: enLang,
  vi: viLang,
  jp: jpLang,
};

export default AppLocale;
